import {
  ModelConstraintCardContainer,
  ModelConstraintCardHeader,
  ModelConstraintContent,
} from './styles'

export type ModelConstraintCardProps = {
  title: string
  subtitle?: React.ReactNode
  tooltipText?: string
  isCheckbox?: boolean
  isCheckboxDisabled?: boolean
  checked?: boolean
  onCheckedChange?: (checked: boolean | 'indeterminate') => void
  rightHeaderContent?: React.ReactNode
  rightHeaderCallback?: () => void
  children?: React.ReactNode
  required?: boolean
  className?: string
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function ModelConstraintCard({
  title,
  subtitle,
  tooltipText,
  isCheckbox = false,
  isCheckboxDisabled = false,
  checked,
  onCheckedChange,
  rightHeaderContent,
  rightHeaderCallback,
  children,
  required = false,
  className,
}: ModelConstraintCardProps) {
  return (
    <ModelConstraintCardContainer className={className}>
      <ModelConstraintCardHeader
        title={title}
        subtitle={subtitle}
        tooltipText={tooltipText}
        rightContent={rightHeaderContent}
        rightCallback={rightHeaderCallback}
        isCheckbox={isCheckbox}
        isCheckboxDisabled={isCheckboxDisabled}
        checked={checked}
        onCheckedChange={onCheckedChange}
        required={required}
      />

      {children && <ModelConstraintContent>{children}</ModelConstraintContent>}
    </ModelConstraintCardContainer>
  )
}
